import {
  Dialog, DialogActions, DialogContent, Grid, Typography, useMediaQuery
} from '@mui/material';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { useTheme } from '@mui/material/styles';
import { BaseButton } from 'components/BaseButton';
import TextField from 'components/text-field';
import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useStyles } from './styles';

type DeleteConfirmationModalProps = {
  title: string,
  confirmationMessage: string,
  isOpen: boolean,
  onConfirm: () => void,
  onClose: () => void,
  isRemoveLoading: boolean,
  buttonConfirmText?: string,
  confirmWord?: string,
  confirmIcon?: IconProp
}

export const DeleteConfirmationModal: FC<DeleteConfirmationModalProps> = ({
  title,
  confirmationMessage,
  isOpen,
  onConfirm,
  onClose,
  isRemoveLoading,
  buttonConfirmText = 'Delete',
  confirmWord,
  confirmIcon = 'trash'
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const { t } = useTranslation();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const [typedWord, setTypedWord] = useState('');
  const wordMismatch = confirmWord !== undefined
    && typedWord.trim().toLowerCase() !== confirmWord.toLowerCase();

  useEffect(() => {
    if (!isOpen) setTypedWord('');
  }, [isOpen]);
  return (
    <Dialog
      open={isOpen}
      fullWidth
      fullScreen={fullScreen}
      classes={fullScreen ? { paper: classes.fullScreenPaper } : undefined}
    >
      <DialogContent className={classes.content} style={{ padding: 0 }}>
        <Grid container direction="column">
          <Grid item>
            <Typography variant="h5" className={classes.title}>
              {title}
            </Typography>
          </Grid>
          <Grid item container className={classes.container}>
            <Grid item>
              <Typography variant="body1" className={classes.message}>
                {confirmationMessage}
              </Typography>
            </Grid>
          </Grid>
          {confirmWord !== undefined && (
            <Grid item container className={classes.container}>
              <TextField
                label={t('users:dialog-confirm-label').replace('${}', confirmWord.toUpperCase())}
                value={typedWord}
                disabled={isRemoveLoading}
                onChange={(event) => setTypedWord(event.target.value)}
              />
            </Grid>
          )}
        </Grid>
      </DialogContent>
      <DialogActions className={classes.actionButtons}>
        <BaseButton
          text={t('common:cancel')}
          icon="times"
          buttonVariant="outlined"
          buttonColor="inherit"
          disabled={isRemoveLoading}
          onClick={onClose}
        />
        <BaseButton
          text={buttonConfirmText}
          icon={confirmIcon}
          buttonVariant="contained"
          backgroundColor={theme.palette.error.main}
          hoverColor={theme.palette.error.dark}
          textColor={theme.palette.error.contrastText}
          isLoading={isRemoveLoading}
          disabled={isRemoveLoading || wordMismatch}
          onClick={onConfirm}
        />
      </DialogActions>
    </Dialog>
  );
};
